import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { Modal } from 'react-responsive-modal'
import cookie from 'react-cookies'
import { isMobile } from 'react-device-detect'

import AppContext from '../../../context/appContext'

import history from '../../../history'
import NavigationBar from '../../NavigationBar/NavigationBar'
import Navigation from '../../Challenges/components/Navigation/Navigation'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericMobileTopNavigation from '../../../GenericComponents/GenericMobileTopNavigation'
import GenericRow from '../../../GenericComponents/GenericRow'

import AppVerIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/app-ver-icon.svg'
import ContactIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/contact-icon.svg'
import FaqIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/faq-icon.svg'
import JoinNewsletterIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/join-newsletter-icon.svg'
import LogoutIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/logout-icon.svg'
import MyAccountIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/my-account-icon.svg'
import PoliciesIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/policies-icon.svg'
import PrivacyIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/privacy-icon.svg'
import RemoveAccountIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/remove-account-icon.svg'
import RemoveFromNewsletterIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/remove-from-newsletter-icon.svg'
import ReportIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/report-icon.svg'
import SubManageIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/sub-manage-icon.svg'
import RemindPasswordIcon from '../../../assets/REDESIGN_Assets/UserProfile/Settings/remind-password-icon.svg'

import changeLocation from '../../../utils/changeLocalization'

import ReportBug from './SingleSetting/ReportBug'
import RemoveFromNewsletter from './SingleSetting/RemoveFromNewsletter'
import AppVersion from './SingleSetting/AppVersion'
import Agreements from './SingleSetting/Agreements'
import Privacy from './SingleSetting/Privacy'
import ManageSub from './SingleSetting/ManageSub'
import RemoveAccount from './SingleSetting/RemoveAccount'
import Contact from './SingleSetting/Contact'
import RemindPassword from './SingleSetting/RemindPassword'

interface SettingsInterface {
  setSettingsMode: Function
  user: any
  isChallengeMode: boolean
}

const Settings: FC<SettingsInterface> = ({
  setSettingsMode,
  user,
  isChallengeMode,
}) => {
  const appContext = useContext(AppContext)
  const [isModalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState('')

  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile ? '95vw' : '55vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  const openSpecificModal = (mode: string) => {
    switch (mode) {
      case 'bug':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'newsletter':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'appVer':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'agreements':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'privacy':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'manageSub':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'removeAccount':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'contact':
        setModalMode(mode)
        setModalOpen(true)
        break
      case 'remindPassword':
        setModalMode(mode)
        setModalOpen(true)
        break
      default:
        break
    }
  }

  const handleGoFaq = () => {
    window.location.href = 'https://fitmatkawariatka.pl/aplikacja-miazga-faq/'
  }

  const logout = () => {
    cookie.remove('accessToken', { path: '/' })
    cookie.remove('refreshToken', { path: '/' })
    cookie.remove('userDemoMode', { path: '/' })

    setTimeout(() => {
      history.push('zaloguj')
    }, 1000)
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard settings'
      }`}
    >
      {isChallengeMode ? (
        <Navigation />
      ) : (
        <NavigationBar
          isPlayerView={false}
          backButtonAction={() => setSettingsMode(false)}
        />
      )}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          dietCartClick={null}
          handleClick={() => setSettingsMode(false)}
        />
      )}
      <GenericMainCard
        margin={'5% auto 0 auto'}
        maxWidth={'1000px'}
        className="standard"
        width={isMobile ? '95%' : '60%'}
        flexDir="row"
        wrap={true}
      >
        <GenericRow
          align={isMobile ? 'center' : 'baseline'}
          margin={isMobile ? '0' : '0 0 5% 0'}
          width={'75%'}
          justify={isMobile ? 'center' : 'center'}
          flexDir={isMobile ? 'column' : 'row'}
        >
          <GenericTextSpan fSize={isMobile ? '2rem' : '1.8rem'}>
            Ustawienia
          </GenericTextSpan>
        </GenericRow>

        <GenericButton
          fSize={'0.9rem'}
          padding={'20px'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('bug')}
        >
          <GenericIcon
            width={'1.3rem'}
            height={'1.3rem'}
            margin={'0 10px 0 0'}
            src={ReportIcon}
          />
          Zgłoś problem
        </GenericButton>

        <GenericButton
          fSize={'0.9rem'}
          padding={'20px'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('newsletter')}
        >
          <GenericIcon
            width={'1.3rem'}
            margin={'0 10px 0 0'}
            height={'1.3rem'}
            src={
              user.is_newsletter_subscriber
                ? RemoveFromNewsletterIcon
                : JoinNewsletterIcon
            }
          />
          {user.is_newsletter_subscriber
            ? ' Usuń z newslettera'
            : 'Dołącz do newslettera'}
        </GenericButton>

        {/* <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={'44%'}
          className={'gradient with-green-arrow'}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={RemoveFromNewsletterIcon}
          />
          Usuń z newslettera
        </GenericButton> */}
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('appVer')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            src={AppVerIcon}
            width={'1.3rem'}
            height={'1.3rem'}
          />
          Wersja aplikacji
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('agreements')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={PoliciesIcon}
          />
          Umowy i regulamin
        </GenericButton>
        {/* <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={MyAccountIcon}
          />
          Moje konto
        </GenericButton> */}
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('privacy')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={PrivacyIcon}
          />
          Polityka prywatności
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => logout()}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={LogoutIcon}
          />
          Wyloguj z aplikacji
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('manageSub')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={SubManageIcon}
          />
          Zarządzanie subskrybcją
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('removeAccount')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={RemoveAccountIcon}
          />
          Usuń konto
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => handleGoFaq()}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={FaqIcon}
          />
          FAQ
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('remindPassword')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={RemindPasswordIcon}
          />
          Przypomnij hasło
        </GenericButton>
        <GenericButton
          padding={'20px'}
          fSize={'0.9rem'}
          margin={'2%'}
          width={isMobile ? '96%' : '44%'}
          className={'gradient with-green-arrow'}
          onClick={() => openSpecificModal('contact')}
        >
          <GenericIcon
            margin={'0 10px 0 0'}
            width={'1.3rem'}
            height={'1.3rem'}
            src={ContactIcon}
          />
          Kontakt
        </GenericButton>
      </GenericMainCard>
      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        {modalMode == 'bug' && (
          <ReportBug closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'newsletter' && (
          <RemoveFromNewsletter closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'appVer' && (
          <AppVersion closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'agreements' && (
          <Agreements closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'privacy' && (
          <Privacy closeModal={() => setModalOpen(false)} />
        )}

        {modalMode == 'manageSub' && (
          <ManageSub closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'removeAccount' && (
          <RemoveAccount closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'contact' && (
          <Contact closeModal={() => setModalOpen(false)} />
        )}
        {modalMode == 'remindPassword' && (
          <RemindPassword closeModal={() => setModalOpen(false)} />
        )}
      </Modal>
    </GenericBackgroundLayer>
  )
}

export default Settings
